// calibrationLogsList/slice.js

import { calibrationLogsListInitialState } from "./calibrationLogsListState";
import { makeCalibrationLogsListActions } from "./calibrationLogsListActions";

export const createCalibrationLogsListSlice = (set, get) => ({
  calibrationLogsList: calibrationLogsListInitialState,
  calibrationLogsListActions: Object.freeze(
    makeCalibrationLogsListActions(set, get)
  ),
});
